import React from 'react';
import { Box, Container, Typography, Link, IconButton, Divider } from '@mui/material';
import { GitHub, Telegram, Email } from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
            Никита Никоноров
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              aria-label="GitHub"
              color="inherit"
              component={Link}
              href="https://github.com/GaredBerns"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GitHub />
            </IconButton>
            <IconButton
              aria-label="Telegram"
              color="inherit"
              component={Link}
              href="https://t.me/GaredBerns187"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Telegram />
            </IconButton>
            <IconButton
              aria-label="Email"
              color="inherit"
              component={Link}
              href="mailto:ru.nnsnns@yandex.ru"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Email />
            </IconButton>
          </Box>
        </Box>
        
        <Divider sx={{ my: 2, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', pt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} Никита Никоноров. Все права защищены.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: { xs: 1, sm: 0 } }}>
            Сделано с <span style={{ color: '#ff6b6b' }}>❤</span> в России
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
